import gql from 'graphql-tag'
export const generateMutation = (mutationType, schema, formSchema, inputName = 'data') => {
    const variables = Object.keys(formSchema.properties).map(field => {
        let variable = `$${field}: `
        const required = formSchema.required.includes(field)
        switch(formSchema.properties[field].type){
            case 'string':
                return `${variable} String${required ? '!' : ''}`
                break
            case 'boolean':
                return `${variable} Boolean${required ? '!' : ''}`
                break
            case 'integer':
            case 'number':
                return `${variable} Int${required ? '!' : ''}`
                break
        }
    })

    const params = Object.keys(formSchema.properties).map(field => `${field}: $${field}`)
    const fields = Object.keys(formSchema.properties)

    return gql`mutation go(${variables.join(', ')}) { ${mutationType}${schema}(${inputName}: {${params.join(', ')}}){${fields.join(' ')}}}`
}